import _ from 'lodash';
// import { rem } from 'polished';
// import styled from 'styled-components';

import React, { useEffect, useState } from 'react';
import { useGetHealthPlan } from 'client/hooks/useGetHealthPlan';
import { getEdeBaseRoute } from 'routes/marketplace-ede/utils/routes';
import { Phase3AppCard } from './cards/Phase3AppCard';
// import { object } from 'prop-types';
// import EnrollmentStatusCard from 'routes/marketplace-ede/web-ui/components/plan/card/enrollmentStatusCard';
// // import Translate from '../../translate';
// // import { PlanTypeIcon } from '../../../../components/enrollment-group/plan/HealthPlanCard';
// import COLORS, { HEX_TRANSPARENT } from 'routes/marketplace-ede/web-ui/constants/colors';
// import Ribbon from 'routes/marketplace-ede/web-ui/components/plan/card/ribbon';
// import 'routes/marketplace-ede/web-ui/styles/planCard.scss';
// import 'routes/marketplace-ede/web-ui/styles/ribbon.scss';

type Props = {
  person: Object,
  group: Object,
  enrollmentStatus: Array<Object>,
  memberDashboard: boolean,
  allowGaAccess: boolean,
  app: Object,
};

// const CompactAppCardContainer = styled.div`
//   background-color: ${COLORS.WHITE};
//   border-radius: ${rem(12)};
//   box-shadow: 0 ${rem(2)} ${rem(10)} 0 ${`${COLORS.GRAY_7}${HEX_TRANSPARENT[50]}`};
//   color: ${COLORS.NAVY_1};
//   cursor: pointer;
//   letter-spacing: 0;
//   padding-bottom: 1.5rem;
//   img {
//     margin-right: ${rem(10)};
//     max-height: 1.5rem;
//     min-width: ${rem(29)};
//   }
// `;

// const CompactRibbonContainer = styled.div`
//   padding-top: 0.5rem;
//   text-align: right;
// `;

const ribbonClasses = {
  waiting: 'waiting',
  cancelled: 'cancelled',
  gtg: 'gtg',
  actionReq: 'action-required',
};

export const enrollStates = {
  strideProcess: {
    displayValue: 'pending',
    translationPath: 'app.enrollmentStatus.strideProcess', // 'Stride Processing',
    className: ribbonClasses.waiting,
  },
  carrierProcess: {
    displayValue: 'submitted',
    translationPath: 'app.enrollmentStatus.carrierProcess', // 'Carrier Processing',
    className: ribbonClasses.waiting,
  },
  ACTIVE_OR_TERMINATED: {
    displayValue: 'accepted',
    translationPath: 'app.enrollmentStatus.covered', // 'Covered',
    className: ribbonClasses.gtg,
  },
  CANCELLED: {
    displayValue: 'cancelled',
    translationPath: 'app.enrollmentStatus.cancelled', // 'Cancelled',
    className: ribbonClasses.cancelled,
  },
  incomplete: {
    translationPath: 'app.enrollmentStatus.incomplete',
    className: ribbonClasses.waiting,
  },
  notFound: {
    translationPath: 'app.enrollmentStatus.notFound',
    className: ribbonClasses.waiting,
  },
  PEND_CANCELED: {
    displayValue: 'cancelled',
    translationPath: 'app.enrollmentStatus.cancelled', // 'Cancelled',
    className: ribbonClasses.cancelled,
  },
  PEND: {
    displayValue: 'ede-pending',
    translationPath: 'app.enrollmentStatus.planPending',
    className: ribbonClasses.waiting,
  },
};

export const mapStatuses = status => enrollStates[status];

export const getStatusType = (enrollmentStatus: Object) =>
  _.get(enrollmentStatus, 'pendedPlanSelectionSummary.currentStatus.statusType') ||
  _.get(enrollmentStatus, 'insurancePolicyStatus.insurancePolicyStatusType');

const EdePhase3Card = ({
  person,
  group,
  enrollmentStatus,
  memberDashboard,
  allowGaAccess,
  app,
}: Props) => {
  const [status, setStatus] = useState({});
  const plan = useGetHealthPlan(person, group);
  const planId = _.get(group, 'product.planId');
  useEffect(() => {
    setStatus(mapStatuses(getStatusType(enrollmentStatus)));
  }, [status]);

  // const planExternalId = _.get(group, 'product.planExternalId');
  const location =
    memberDashboard || !plan
      ? `${getEdeBaseRoute({
        stateCode: app.coverageState,
        year: app.coverageYear,
        allowGaAccess,
      })}/old-post-enrollment/dashboard`
      : `${getEdeBaseRoute({
        stateCode: app.coverageState,
        year: app.coverageYear,
        allowGaAccess,
      })}/post-enrollment/plan/${planId}/dashboard`;

  return plan ? (
    <Phase3AppCard
      plan={plan.plan}
      status={status}
      isCard
      isCompactView
      clickHandler={() => (window.location = location)} />
  ) : // <div clasName="margin bottom pad">
  //   <CompactAppCardContainer>
  //     {status && (
  //       <CompactRibbonContainer>
  //         <Ribbon
  //           className={status.className}
  //           content={status.content}
  //           isCompactRibbon
  //           wrapAround />
  //       </CompactRibbonContainer>
  //     )}
  //     {plan.plan.carrier}
  //     {plan.plan.planName}
  //   </CompactAppCardContainer>
  // </div>
    null;
};

export default EdePhase3Card;
